import { ApiError } from '../api/errors';

/**
 * How `PUT /notes/{id}/review` can refuse a save, from `backend/app/api/review.py`'s error
 * codes. Kept as a pure classifier (mirroring `history/retryClassification.ts`'s pattern) so
 * `ReviewScreen` can branch on outcome without re-deriving the status/code pairing inline.
 */
export type SaveFailureKind =
  'session_expired' | 'revision_conflict' | 'not_reviewable' | 'invalid_reference' | 'other';

const REVISION_CONFLICT_CODE = 'revision_conflict';
const NOT_REVIEWABLE_CODE = 'note_not_reviewable';
const INVALID_REFERENCE_CODE = 'invalid_reference';

export function classifySaveFailure(error: ApiError): SaveFailureKind {
  if (error.isSessionInvalid) {
    return 'session_expired';
  }
  if (error.status === 409 && error.code === REVISION_CONFLICT_CODE) {
    return 'revision_conflict';
  }
  if (error.status === 409 && error.code === NOT_REVIEWABLE_CODE) {
    return 'not_reviewable';
  }
  if (error.status === 422 && error.code === INVALID_REFERENCE_CODE) {
    return 'invalid_reference';
  }
  return 'other';
}
